<script>
import GenericResourcesView from "@/components/GenericResourcesView";
import ErrorMessage from "@/components/ErrorMessage";
import features from "@/configs/features";
import Button from "@/components/Button";
import bus from "@/bus";
import { useUserStore } from "../stores/user";
import { useResourcesStore } from "../stores/resources";
import { useConsentStore } from "../stores/consent";

export default {
  setup() {
    const userStore = useUserStore();
    const resourcesStore = useResourcesStore();
    const consentStore = useConsentStore();
    
    return {
      userStore,
      resourcesStore,
      consentStore,
    };
  },
  components: {
    GenericResourcesView,
    ErrorMessage,
    Button
  },
  data() {
    return {
      buttons: [
        {
          id: "download",
          label: "views.mairie.button",
          color: "airbnbBlue",
        },
      ],
      gridError: null,
      showMessage: true,
      userUpdatedMessage: "views.mairie.infos.update_message",
    };
  },
  computed: {
    features: () => features,
    user() {
      return this.userStore.getData;
    },
    towns() {
      return this.user.townsData;
    },
  },
  mounted() {
    bus.on("download", this.downloadFile);
  },
  methods: {
    townTitle(town) {
      if (!features.INSEE && !features.DEPART) return town.town;
      return `${town.town}\xa0(${town.departement || town.insee})`;
    },
    openModal(modal) {
      bus.emit("openModal", { modal: modal, params: {} });
    },
    closeMessage() {
      this.showMessage = false;
    },
    async downloadFile({ id }) {
      if (!this.consentStore.is_present()) {
        bus.emit("openModal", {
          modal: "termsConsent",
          params: {
            import_data_id: id,
          },
        });
      } else {
        this.resourcesStore.downloadTownFile({ import_data_id: id })
      }
    },
  },
};
</script>

<template>
  <div class="mt-6 px-8 w-full">
    <h1 class="mb-4 text-3xl font-light text-lightGrey" data-cy="nameContainer">
      {{ $t("views.mairie.title") }} {{ user.firstname }}
      {{ user.lastname && user.lastname.toUpperCase() }}
    </h1>
    <div class="flex flex-row justify-between">
      <span class="text-lightGrey py-2" data-cy="phoneContainer">
        <b>{{ $t("views.mairie.phone") }}</b> {{ user.phone }}
      </span>
      <span class="text-lightGrey py-2" data-cy="mailContainer">
        <b>{{ $t("views.mairie.email") }}</b> {{ user.email }}
      </span>
    </div>
    <div data-cy="userTownList" class="text-lightGrey leading-normal">
      <b>{{ $t("views.mairie.cities") }}</b><span v-for="t in towns" :key="t.id" class="px-1 m-1 rounded bg-blue-200">{{
        townTitle(t) }}</span>
      <span v-if="user.role === 'Updated'">{{ $t(userUpdatedMessage) }}</span>
    </div>
    
    <hr class="my-6 border-t border-solid border-gray-200" />
    <ErrorMessage v-if="user.role === 'Updated' && showMessage === true"
      :value="{ status: 302, message: userUpdatedMessage }" @input="closeMessage" />

    <div class="w-full flex flex-row justify-center">
      <Button class="mr-16" bg="airbnbBlue" data-cy="modifyUserDataButton" @click="openModal('editUserData')">
        {{ $t("views.mairie.modify") }}
      </Button>
      <Button bg="airbnbBlue" data-cy="modifyUserTownButton" @click="openModal('editUserTown')">
        {{ $t("views.mairie.add_delete") }}
      </Button>
    </div>

    <hr class="my-8 border-t border-solid border-gray-200" />

    <h2 class="text-3xl font-light text-lightGrey mb-4">
      {{ $t("views.mairie.tax") }}<br />
      <span class="text-base font-normal leading-tight">{{
        $t("views.mairie.download")
      }}</span>
    </h2>
    <ErrorMessage v-if="gridError" :value="gridError" @input="gridError = null" />
    <p class="pb-3 text-lightGrey">
      {{ $t("views.mairie.infos.1") }}
    </p>
    <GenericResourcesView type="mairie" :buttons="buttons" />
  </div>
</template>